import { lazy } from 'react';

const CustomTestStatics = lazy(() => import('./TestStatistics.js'));

export default CustomTestStatics;
